<script lang="ts">
  import { i18n } from "../i18n.svelte";
  import { inview } from "../actions";
  import SectionHead from "./SectionHead.svelte";
  import Sprout from "./Sprout.svelte";
  import ImagePlaceholder from "./ImagePlaceholder.svelte";

  const u = $derived(i18n.t.usecases);
  // stable, locale-independent image slugs (match content item order)
  const slugs = [
    "exam-students",
    "working-adults",
    "parents",
    "japanese-learners",
    "schools",
    "adult-learners",
  ];
  const stages = [2, 3, 4, 2, 3, 4] as const;
</script>

<section class="section section--rule" id="usecases">
  <div class="container">
    <SectionHead label={u.label} title={u.title} lead={u.lead} />

    <div class="grid">
      {#each u.items as item, i}
        <article class="card uc reveal" use:inview={{ delay: (i % 3) * 90 }}>
          <div class="banner">
            <ImagePlaceholder
              src={`/images/usecases/${slugs[i]}.png`}
              alt={item.t}
              ratio="16 / 10"
              label={u.imageAlt}
              rounded={false}
            />
            <span class="tag"><span class="seed"><Sprout size={15} stage={stages[i]} /></span>{item.tag}</span>
          </div>
          <div class="body">
            <h3>{item.t}</h3>
            <p>{item.d}</p>
          </div>
        </article>
      {/each}
    </div>
  </div>
</section>

<style>
  .grid {
    margin-top: clamp(2.5rem, 1.5rem + 3vw, 4rem);
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.2rem;
  }
  .uc {
    padding: 0;
    overflow: hidden;
    transition:
      transform 0.4s var(--ease),
      box-shadow 0.4s var(--ease),
      border-color 0.4s var(--ease);
  }
  .uc:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-soft);
    border-color: var(--sprout);
  }
  .banner {
    position: relative;
  }
  .tag {
    position: absolute;
    bottom: 0.7rem;
    left: 0.7rem;
    display: inline-flex;
    align-items: center;
    gap: 0.4em;
    font-family: var(--font-mono);
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: var(--green-deep);
    background: rgba(251, 248, 240, 0.92);
    backdrop-filter: blur(4px);
    border: 1px solid var(--line);
    padding: 0.35em 0.7em 0.35em 0.4em;
    border-radius: 999px;
  }
  .tag .seed {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: var(--sprout-soft);
    display: grid;
    place-items: center;
  }
  .body {
    padding: 1.2rem 1.4rem 1.6rem;
  }
  h3 {
    font-size: 1.22rem;
  }
  p {
    margin-top: 0.6rem;
    color: var(--ink-soft);
    font-size: 0.95rem;
    line-height: 1.8;
  }

  @media (max-width: 880px) {
    .grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media (max-width: 560px) {
    .grid {
      grid-template-columns: 1fr;
    }
  }
</style>
